<!-- This is a simple helper used to help us get access to children in tests on Teleported components -->
<template>
  <slot />
</template>
